module.exports = __webpack_public_path__ + "static/media/pagination-next.b4f50f1b.svg";